import { RouteConfig } from 'vue-router';

import { profileRoute } from './profile/profile.route';
import { profilesRoute } from './profile/profiles.route';

export const profileContainerRoute: RouteConfig = {
  path: 'profile',
  component: () => import(/* webpackChunkName: "RouterView" */ '@/components/appLayout/Router.vue'),
  children: [profilesRoute, profileRoute],
  meta: {
    authorized: true,

    config: {
      title: 'Lista profili',
      icon: 'fal fa-users',
      name: 'profiles',
      permissions: ['USER.LIST'],
      group: 'Użytkownicy'
    },

    breadcrumb: {
      title: 'Lista profili',
      name: 'profiles'
    }
  },
  redirect: { name: 'profiles' }
};
